import { roundValue } from "lib/number";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { ValueGetterParams } from "ag-grid-community";
import { loopGridNode, referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenTotalRetail } from "./total-retail";
import memoizeOne from "memoize-one";

/**
 * Get aggregrated total retail of the entire column. Loop through all row nodes and sum their values.
 */
const getColumnTotalRetail = memoizeOne(
    (options: MergedColumnFormulaOptions, valueGetterParams: ValueGetterParams) => {
        let totalRetail = 0;
        loopGridNode(valueGetterParams.api, (childNode) => {
            const childGetterParams = {
                ...valueGetterParams,
                node: childNode,
                data: childNode.data,
            };
            const retail = referenceMetricValueOrCompute(
                () => getChildrenTotalRetail(options, childGetterParams),
                childGetterParams,
                MetricsKind.TOTAL_RETAIL
            );
            totalRetail += retail;
        });

        return totalRetail;
    },
    (newArgs, oldArgs) =>
        newArgs[1].colDef.colId === oldArgs[1].colDef.colId && newArgs[1].node.id === oldArgs[1].node.id
);

export const ROW_PERCENTAGE_PLAN = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const retailValue = referenceMetricValueOrCompute(
        () => getChildrenTotalRetail(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.TOTAL_RETAIL
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!retailValue) {
        return 0;
    }

    const totalRetailValue = getColumnTotalRetail(options, gridGetterParams);

    return totalRetailValue > 0 ? roundValue((retailValue / totalRetailValue) * 100, options.decimal) : 0;
};
